// extracted by mini-css-extract-plugin
module.exports = {"selector":"_2l3aM","address":"_3fTeX","banner":"CyMjm","label":"_2G8rc","text":"_1lWKw","map":"_2WRPi","minOrderPrice":"_1mEZI"};